module.exports = __webpack_public_path__ + "img/LBR.1be70c05.svg";